import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class StudentGroupsTableRefreshService {
	constructor() {}

	//Assign / Unassign
	private refreshCalled = new Subject<any>();
	refreshChanged(msg) {
		this.refreshCalled.next(msg);
	}

	onRefresh(): Observable<any> {
		return this.refreshCalled.asObservable();
	}

	//Group actions
	private GroupActionRefreshCalled = new Subject<any>();
	GroupActionRefreshChanged(msg) {
		this.GroupActionRefreshCalled.next(msg);
	}

	onGroupActionRefresh(): Observable<any> {
		return this.GroupActionRefreshCalled.asObservable();
	}
}
